// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import scroll from 'vue-seamless-scroll'
import 'amfe-flexible/index'
// import './css/animista.css'
import 'hover.css'
window.addEventListener('scroll', (e) => {
  const images = document.querySelectorAll('img')
  images.forEach(image => {
    const imageTop = image.getBoundingClientRect().top
    if (imageTop < window.innerHeight) {
      const dataSrc = image.getAttribute('data-src')
      image.setAttribute('src', dataSrc)
    }
  })
})
Vue.use(scroll)
Vue.use(ElementUI)
Vue.config.productionTip = false
router.afterEach(() => {
  window.scrollTo(0, 0)
})
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js